import {
	VIDEO_ELEMENT,
	REFLECTION_ELEMENT,
	SURVEY_ELEMENT,
	LINK_ELEMENT,
	IMAGE_ELEMENT,
	AUDIO_ELEMENT,
	DOWNLOAD_ELEMENT,
	TEXT_ELEMENT,
	DOCUMENT_ELEMENT,
	SIGNATURE_ELEMENT
} from '../models/Constants';

import { ROLE_ADMIN, ROLE_MENTOR, ROLE_OWNER } from '../models/Constants';

export const getRole = (roleID) => {
	switch(roleID) {
		case 1:
			return "Admin";
		case 2:
			return "Student";
		case 3:
			return "Mentor";
		case 4:
			return "Super Admin";
		case 5:
			return "Employee";
		case 6:
			return "Owner";
	}
}

export const getCompanyCapabilities = (userCapabilities, companyID) => {
	let selected;

	for(const obj of userCapabilities) {
		if(obj.company_id === companyID) {
			selected = obj;
			break;
		}
	}

	return selected;
}

export const getElementType = (elementTypeID) => {
	switch(elementTypeID) {
		case VIDEO_ELEMENT:
			return "Video";
		case REFLECTION_ELEMENT:
			return "Reflection";
		case SURVEY_ELEMENT:
			return "Survey";
		case LINK_ELEMENT:
			return "Link";
		case IMAGE_ELEMENT:
			return "Image";
		case AUDIO_ELEMENT:
			return "Audio";
		case DOWNLOAD_ELEMENT:
			return "Download";
		case TEXT_ELEMENT:
			return "Text";
		case DOCUMENT_ELEMENT:
			return "Document";
		case SIGNATURE_ELEMENT:
			return "Signature";
	}
}

export const isAdminOrMentor = (role) => {
	return role == ROLE_ADMIN || role == ROLE_MENTOR || role == ROLE_OWNER;
}

export const isAdminOrOwner = (role) => {
	return role == ROLE_ADMIN || role == ROLE_OWNER;
}